import styled from 'styled-components';
import { Props } from './index';

export const Wrapper = styled.button`
  @import url('https://fonts.googleapis.com/css2?family=Open+Sans:wght@500;600&display=swap');
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ variant, backgroundColor }: Props) =>
    variant === 'outlined' ? 'transparent' : backgroundColor};
  color: ${({ color }: Props) => color};
  padding: 12px 40px;
  box-sizing: border-box;
  font-size: 16px;
  font-family: 'Open Sans', sans-serif;
  font-weight: 600;
  flex: 1;
  width: 100%;
  border: ${({ backgroundColor }: Props) => '2px solid' + backgroundColor};
  border-radius: 100px;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${({ variant }: Props) =>
      variant === 'outlined' ? '#2B45D40A' : '#243AB2'};
  }

  &:disabled {
    opacity: 0.4;
    pointer-events: none;
    cursor: not-allowed;
  }
`;
